import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbCarouselModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';


import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import {
    TimelineComponent,
    NotificationComponent,
    ChatComponent
} from './components';
import { StatModule } from '../../shared';
import {DashboardProvider} from './dashboard-provider';
import {TimelineProvider} from './components/timeline/timeline.provider';
import {NotificationProvider} from './components/notification/notification.provider';
import {AngularMaterialModule} from '../../app-module/angular-matrial.module';
//import { NgxChartsModule }from '@swimlane/ngx-charts';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
@NgModule({
    imports: [
        CommonModule,
        NgbCarouselModule.forRoot(),
        NgbAlertModule.forRoot(),
        DashboardRoutingModule,
        StatModule,
        AngularMaterialModule,
//            NgxChartsModule,

        
    ],
    declarations: [
        DashboardComponent,
        TimelineComponent,
        NotificationComponent,
        ChatComponent,
    ],
    providers:[DashboardProvider,TimelineProvider, NotificationProvider]
})
export class DashboardModule {}
